/**
 * Layout 4 -- block chart: the organisation drawn top-down. A root block, one
 * column per group with its owners, each unit a card beneath it, each client a
 * row inside its unit. Blocks open the detail panel; names link on from there.
 */

import { ContextTag, HolderBox, HolderChip } from './OverviewParts';
import { pluralise, type OrgNode } from './overviewModel';
import type { ViewProps } from './viewProps';

export function BlocksView({ roots, tree, onSelect }: ViewProps) {
  return (
    <div className="card ov-bc-scroll">
      <div className="ov-bc">
        <div className="ov-bc-root">
          <b>GFT US</b>
          <span>
            {pluralise(tree.totals.business_units, 'unit')} · {pluralise(tree.totals.engagements, 'engagement')}
          </span>
        </div>
        <div className="ov-stem" />
        <div className="ov-groups">
          {roots.map((group) => (
            <div className="ov-gcol" key={group.id}>
              <button type="button" className="ov-ghead" onClick={() => onSelect(group.id)}>
                <div>
                  <h4>
                    {group.name} <ContextTag node={group} />
                  </h4>
                  <div className="meta">
                    {pluralise(group.counts.business_units, 'unit')} · {pluralise(group.counts.clients, 'client')}
                  </div>
                </div>
                {group.inScope && (
                  <div className="ov-rolepair">
                    <HolderBox holder={group.delivery} kind="delivery" />
                    <HolderBox holder={group.sales} kind="sales" />
                  </div>
                )}
              </button>
              <div className="ov-stem" />
              <div className="ov-gbody">
                {group.children.map((unit) => (
                  <UnitBlock key={unit.id} unit={unit} onSelect={onSelect} />
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

function UnitBlock({ unit, onSelect }: { unit: OrgNode; onSelect: (id: string) => void }) {
  return (
    <div className="ov-bucard">
      <button type="button" className="ov-bu-head" onClick={() => onSelect(unit.id)}>
        <h5>
          {unit.name} <ContextTag node={unit} />
        </h5>
        {unit.inScope && (
          <div className="ov-pair">
            <HolderChip holder={unit.delivery} kind="delivery" compact />
            <HolderChip holder={unit.sales} kind="sales" compact />
          </div>
        )}
      </button>
      {unit.children.map((client) => (
        <button type="button" className="ov-crow" key={client.id} onClick={() => onSelect(client.id)}>
          <span className="t">{client.name}</span>
          <span className="e">{client.counts.engagements} eng.</span>
          {client.inScope && (
            <span className="rs">
              <HolderChip holder={client.delivery} kind="delivery" compact />
              <HolderChip holder={client.sales} kind="sales" compact />
            </span>
          )}
        </button>
      ))}
    </div>
  );
}
